import { combineReducers } from "redux";

import NppesDetailsDataReducer from "../reducers/NppesDetailsData";
import PriorAuthReferralSource from "../reducers/ReferralSource";
import DiseaseType from "../reducers/DiseaseType";
import IcdCodeType from "../reducers/IcdCodeType";
import TabSessionStorage from "../reducers/TabSessionStorage";
import DocumentDownloadReducer from "../reducers/DocumentUpload";
import CareTypeReducer from "../reducers/CareTypesMaster";
import DisciplinesReducer from "../reducers/DisciplineMaster";
import MasterLanguageReducer from "../reducers/LanuageMaster";
import RelationshipReducer from "../reducers/RelationshipMaster";
import PayerReducer from "../reducers/PayerList";
import CheckEligibility from "../reducers/CheckEligibility";
import RequestAuthorization from "../reducers/RequestAuthorization";
import ReferralRequestor from "../reducers/ReferralRequestor";
import EligibilityInformation from "../reducers/EligibilityInformation";

const createRootReducer = combineReducers({
  TabSessionStorageState: TabSessionStorage,
  disaseTypeState: DiseaseType,
  icdCodeTypeState: IcdCodeType,
  careTypeState: CareTypeReducer,
  disciplineState: DisciplinesReducer,
  languageMasterState: MasterLanguageReducer,
  relationMasterState: RelationshipReducer,
  DocumentUploadState: DocumentDownloadReducer,
  NPPESDataState: NppesDetailsDataReducer,
  priorAuthReferralSourceState: PriorAuthReferralSource,
  payerState: PayerReducer,
  checkEligibilityState: CheckEligibility,
  requestAuthorizationState: RequestAuthorization,
  referralRequestorState: ReferralRequestor,
  eligibilityInformationState: EligibilityInformation
});

export default createRootReducer;
